module.exports = __webpack_public_path__ + "img/partner12.f4892852.png";